import { Action, SubmenuAction, Separator } from 'vscode/vscode/vs/base/common/actions';
import { Codicon } from 'vscode/vscode/vs/base/common/codicons';
import { Schemas } from 'vscode/vscode/vs/base/common/network';
import { localizeWithPath, localize2WithPath } from 'vscode/vscode/vs/nls';
import { MenuRegistry, MenuId } from 'vscode/vscode/vs/platform/actions/common/actions';
import { ContextKeyExpr } from 'vscode/vscode/vs/platform/contextkey/common/contextkey';
import { TerminalLocation } from 'vscode/vscode/vs/platform/terminal/common/terminal';
import { ResourceContextKey } from 'vscode/vscode/vs/workbench/common/contextkeys';
import { TaskExecutionSupportedContext } from 'vscode/vscode/vs/workbench/contrib/tasks/common/taskService';
import { TERMINAL_VIEW_ID } from 'vscode/vscode/vs/workbench/contrib/terminal/common/terminal';
import { TerminalContextKeys } from 'vscode/vscode/vs/workbench/contrib/terminal/common/terminalContextKey';
import { terminalStrings } from '../common/terminalStrings.js';
import { ACTIVE_GROUP, SIDE_GROUP } from 'vscode/vscode/vs/workbench/services/editor/common/editorService';

const _moduleId = "vs/workbench/contrib/terminal/browser/terminalMenus";
function setupTerminalMenus() {
    MenuRegistry.appendMenuItems([
        {
            id: MenuId.MenubarTerminalMenu,
            item: {
                group: "1_create" ,
                command: {
                    id: "workbench.action.terminal.new" ,
                    title: ( localizeWithPath(_moduleId, 0, "&&New Terminal"))
                },
                order: 1
            }
        },
        {
            id: MenuId.MenubarTerminalMenu,
            item: {
                group: "1_create" ,
                command: {
                    id: "workbench.action.terminal.split" ,
                    title: ( localizeWithPath(_moduleId, 1, "&&Split Terminal")),
                    precondition: ( (ContextKeyExpr.has("terminalIsOpen" )))
                },
                order: 2,
                when: TerminalContextKeys.processSupported
            }
        },
        {
            id: MenuId.MenubarTerminalMenu,
            item: {
                group: "3_run" ,
                command: {
                    id: "workbench.action.terminal.runActiveFile" ,
                    title: ( localizeWithPath(_moduleId, 2, "Run &&Active File"))
                },
                order: 3,
                when: TerminalContextKeys.processSupported
            }
        },
        {
            id: MenuId.MenubarTerminalMenu,
            item: {
                group: "3_run" ,
                command: {
                    id: "workbench.action.terminal.runSelectedText" ,
                    title: ( localizeWithPath(_moduleId, 3, "Run &&Selected Text"))
                },
                order: 4,
                when: TerminalContextKeys.processSupported
            }
        }
    ]);
    MenuRegistry.appendMenuItems([
        {
            id: MenuId.TerminalInstanceContext,
            item: {
                group: "1_create" ,
                command: {
                    id: "workbench.action.terminal.split" ,
                    title: terminalStrings.split.value
                }
            }
        },
        {
            id: MenuId.TerminalInstanceContext,
            item: {
                command: {
                    id: "workbench.action.terminal.new" ,
                    title: terminalStrings.new
                },
                group: "1_create"
            }
        },
        {
            id: MenuId.TerminalInstanceContext,
            item: {
                command: {
                    id: "workbench.action.terminal.killViewOrEditor" ,
                    title: terminalStrings.kill.value,
                },
                group: "7_kill"
            }
        },
        {
            id: MenuId.TerminalInstanceContext,
            item: {
                command: {
                    id: "workbench.action.terminal.copySelection" ,
                    title: ( localizeWithPath(_moduleId, 4, "Copy"))
                },
                group: "3_edit" ,
                order: 1
            }
        },
        {
            id: MenuId.TerminalInstanceContext,
            item: {
                command: {
                    id: "workbench.action.terminal.copySelectionAsHtml" ,
                    title: ( localizeWithPath(_moduleId, 5, "Copy as HTML"))
                },
                group: "3_edit" ,
                order: 2
            }
        },
        {
            id: MenuId.TerminalInstanceContext,
            item: {
                command: {
                    id: "workbench.action.terminal.paste" ,
                    title: ( localizeWithPath(_moduleId, 6, "Paste"))
                },
                group: "3_edit" ,
                order: 3
            }
        },
        {
            id: MenuId.TerminalInstanceContext,
            item: {
                command: {
                    id: "workbench.action.terminal.clear" ,
                    title: ( localizeWithPath(_moduleId, 7, "Clear"))
                },
                group: "5_clear" ,
            }
        },
        {
            id: MenuId.TerminalInstanceContext,
            item: {
                command: {
                    id: "workbench.action.terminal.sizeToContentWidth" ,
                    title: terminalStrings.toggleSizeToContentWidth
                },
                group: "9_config"
            }
        },
        {
            id: MenuId.TerminalInstanceContext,
            item: {
                command: {
                    id: "workbench.action.terminal.selectAll" ,
                    title: ( localizeWithPath(_moduleId, 8, "Select All")),
                },
                group: "3_edit" ,
                order: 3
            }
        },
    ]);
    MenuRegistry.appendMenuItems([
        {
            id: MenuId.TerminalEditorInstanceContext,
            item: {
                group: "1_create" ,
                command: {
                    id: "workbench.action.terminal.split" ,
                    title: terminalStrings.split.value
                }
            }
        },
        {
            id: MenuId.TerminalEditorInstanceContext,
            item: {
                command: {
                    id: "workbench.action.terminal.new" ,
                    title: terminalStrings.new
                },
                group: "1_create"
            }
        },
        {
            id: MenuId.TerminalEditorInstanceContext,
            item: {
                command: {
                    id: "workbench.action.terminal.killEditor" ,
                    title: terminalStrings.kill.value
                },
                group: "7_kill"
            }
        },
        {
            id: MenuId.TerminalEditorInstanceContext,
            item: {
                command: {
                    id: "workbench.action.terminal.copySelection" ,
                    title: ( localizeWithPath(_moduleId, 4, "Copy"))
                },
                group: "3_edit" ,
                order: 1
            }
        },
        {
            id: MenuId.TerminalEditorInstanceContext,
            item: {
                command: {
                    id: "workbench.action.terminal.copySelectionAsHtml" ,
                    title: ( localizeWithPath(_moduleId, 5, "Copy as HTML"))
                },
                group: "3_edit" ,
                order: 2
            }
        },
        {
            id: MenuId.TerminalEditorInstanceContext,
            item: {
                command: {
                    id: "workbench.action.terminal.paste" ,
                    title: ( localizeWithPath(_moduleId, 6, "Paste"))
                },
                group: "3_edit" ,
                order: 3
            }
        },
        {
            id: MenuId.TerminalEditorInstanceContext,
            item: {
                command: {
                    id: "workbench.action.terminal.clear" ,
                    title: ( localizeWithPath(_moduleId, 7, "Clear"))
                },
                group: "5_clear" ,
            }
        },
        {
            id: MenuId.TerminalEditorInstanceContext,
            item: {
                command: {
                    id: "workbench.action.terminal.selectAll" ,
                    title: ( localizeWithPath(_moduleId, 8, "Select All")),
                },
                group: "3_edit" ,
                order: 3
            }
        },
        {
            id: MenuId.TerminalEditorInstanceContext,
            item: {
                command: {
                    id: "workbench.action.terminal.sizeToContentWidth" ,
                    title: terminalStrings.toggleSizeToContentWidth
                },
                group: "9_config"
            }
        }
    ]);
    MenuRegistry.appendMenuItems([
        {
            id: MenuId.TerminalTabEmptyAreaContext,
            item: {
                command: {
                    id: "workbench.action.terminal.newWithProfile" ,
                    title: ( localizeWithPath(_moduleId, 9, "New Terminal With Profile..."))
                },
                group: "1_create"
            }
        },
        {
            id: MenuId.TerminalTabEmptyAreaContext,
            item: {
                command: {
                    id: "workbench.action.terminal.new" ,
                    title: terminalStrings.new
                },
                group: "1_create"
            }
        }
    ]);
    MenuRegistry.appendMenuItems([
        {
            id: MenuId.TerminalNewDropdownContext,
            item: {
                command: {
                    id: "workbench.action.terminal.selectDefaultShell" ,
                    title: ( localize2WithPath(_moduleId, 10, 'Select Default Profile')),
                },
                group: '3_configure'
            }
        },
        {
            id: MenuId.TerminalNewDropdownContext,
            item: {
                command: {
                    id: "workbench.action.terminal.openSettings" ,
                    title: ( localizeWithPath(_moduleId, 11, "Configure Terminal Settings"))
                },
                group: '3_configure'
            }
        },
        {
            id: MenuId.TerminalNewDropdownContext,
            item: {
                command: {
                    id: 'workbench.action.tasks.runTask',
                    title: ( localizeWithPath(_moduleId, 12, "Run Task..."))
                },
                when: TaskExecutionSupportedContext,
                group: '4_tasks',
                order: 1
            },
        },
        {
            id: MenuId.TerminalNewDropdownContext,
            item: {
                command: {
                    id: 'workbench.action.tasks.configureTaskRunner',
                    title: ( localizeWithPath(_moduleId, 13, "Configure Tasks..."))
                },
                when: TaskExecutionSupportedContext,
                group: '4_tasks',
                order: 2
            },
        }
    ]);
    MenuRegistry.appendMenuItems([
        {
            id: MenuId.ViewTitle,
            item: {
                command: {
                    id: "workbench.action.terminal.switchTerminal" ,
                    title: ( localize2WithPath(_moduleId, 14, 'Switch Terminal'))
                },
                group: 'navigation',
                order: 0,
                when: ( (ContextKeyExpr.and(
                     (ContextKeyExpr.equals('view', TERMINAL_VIEW_ID)),
                    ContextKeyExpr.not(`config.${"terminal.integrated.tabs.enabled" }`)
                ))),
            }
        },
        {
            id: MenuId.ViewTitle,
            item: {
                command: {
                    id: "workbench.action.terminal.focus" ,
                    title: terminalStrings.focus
                },
                alt: {
                    id: "workbench.action.terminal.split" ,
                    title: terminalStrings.split.value,
                    icon: Codicon.splitHorizontal
                },
                group: 'navigation',
                order: 0,
                when: ( (ContextKeyExpr.and(
                     (ContextKeyExpr.equals('view', TERMINAL_VIEW_ID)),
                     (ContextKeyExpr.has(
                        `config.${"terminal.integrated.tabs.enabled" }`
                    )),
                     (ContextKeyExpr.or( (ContextKeyExpr.and( (ContextKeyExpr.equals(
                        `config.${"terminal.integrated.tabs.showActiveTerminal" }`,
                        'singleTerminal'
                    )),  (ContextKeyExpr.equals("terminalGroupCount", 1)))),  (ContextKeyExpr.and( (ContextKeyExpr.equals(
                        `config.${"terminal.integrated.tabs.showActiveTerminal" }`,
                        'singleTerminalOrNarrow'
                    )),  (ContextKeyExpr.or(
                         (ContextKeyExpr.equals("terminalGroupCount", 1)),
                         (ContextKeyExpr.has("isTerminalTabsNarrow" ))
                    )))),  (ContextKeyExpr.and( (ContextKeyExpr.equals(
                        `config.${"terminal.integrated.tabs.showActiveTerminal" }`,
                        'singleGroup'
                    )),  (ContextKeyExpr.equals("terminalGroupCount", 1)))),  (ContextKeyExpr.equals(
                        `config.${"terminal.integrated.tabs.showActiveTerminal" }`,
                        'always'
                    ))))
                ))),
            }
        },
        {
            id: MenuId.ViewTitle,
            item: {
                command: {
                    id: "workbench.action.terminal.split" ,
                    title: terminalStrings.split,
                    icon: Codicon.splitHorizontal
                },
                group: 'navigation',
                order: 2,
                when: TerminalContextKeys.shouldShowViewInlineActions
            }
        },
        {
            id: MenuId.ViewTitle,
            item: {
                command: {
                    id: "workbench.action.terminal.kill" ,
                    title: terminalStrings.kill,
                    icon: Codicon.trash
                },
                group: 'navigation',
                order: 3,
                when: TerminalContextKeys.shouldShowViewInlineActions
            }
        },
        {
            id: MenuId.ViewTitle,
            item: {
                command: {
                    id: "workbench.action.terminal.new" ,
                    title: terminalStrings.new,
                    icon: Codicon.plus
                },
                alt: {
                    id: "workbench.action.terminal.split" ,
                    title: terminalStrings.split.value,
                    icon: Codicon.splitHorizontal
                },
                group: 'navigation',
                order: 0,
                when: ( (ContextKeyExpr.and(
                     (ContextKeyExpr.equals('view', TERMINAL_VIEW_ID)),
                     (ContextKeyExpr.or(
                        TerminalContextKeys.webExtensionContributedProfile,
                        TerminalContextKeys.processSupported
                    ))
                )))
            }
        },
        {
            id: MenuId.ViewTitle,
            item: {
                command: {
                    id: "workbench.action.terminal.clear" ,
                    title: ( localizeWithPath(_moduleId, 15, "Clear Terminal")),
                    icon: Codicon.clearAll
                },
                group: 'navigation',
                order: 4,
                when: ( (ContextKeyExpr.equals('view', TERMINAL_VIEW_ID))),
                isHiddenByDefault: true
            }
        },
        {
            id: MenuId.ViewTitle,
            item: {
                command: {
                    id: "workbench.action.terminal.runActiveFile" ,
                    title: ( localizeWithPath(_moduleId, 16, "Run Active File")),
                    icon: Codicon.run
                },
                group: 'navigation',
                order: 5,
                when: ( (ContextKeyExpr.equals('view', TERMINAL_VIEW_ID))),
                isHiddenByDefault: true
            }
        },
        {
            id: MenuId.ViewTitle,
            item: {
                command: {
                    id: "workbench.action.terminal.runSelectedText" ,
                    title: ( localizeWithPath(_moduleId, 17, "Run Selected Text")),
                    icon: Codicon.selection
                },
                group: 'navigation',
                order: 6,
                when: ( (ContextKeyExpr.equals('view', TERMINAL_VIEW_ID))),
                isHiddenByDefault: true
            }
        },
    ]);
    MenuRegistry.appendMenuItems([
        {
            id: MenuId.TerminalTabContext,
            item: {
                command: {
                    id: "workbench.action.terminal.splitActiveTab" ,
                    title: terminalStrings.split.value,
                },
                group: "1_create" ,
                order: 1
            }
        },
        {
            id: MenuId.TerminalTabContext,
            item: {
                command: {
                    id: "workbench.action.terminal.moveToEditor" ,
                    title: terminalStrings.moveToEditor.value
                },
                group: "1_create" ,
                order: 2
            }
        },
        {
            id: MenuId.TerminalTabContext,
            item: {
                command: {
                    id: "workbench.action.terminal.moveIntoNewWindow" ,
                    title: terminalStrings.moveIntoNewWindow.value
                },
                group: "1_create" ,
                order: 2
            }
        },
        {
            id: MenuId.TerminalTabContext,
            item: {
                command: {
                    id: "workbench.action.terminal.renameActiveTab" ,
                    title: ( localizeWithPath(_moduleId, 18, "Rename..."))
                },
                group: "3_edit"
            }
        },
        {
            id: MenuId.TerminalTabContext,
            item: {
                command: {
                    id: "workbench.action.terminal.changeIconActiveTab" ,
                    title: ( localizeWithPath(_moduleId, 19, "Change Icon..."))
                },
                group: "3_edit"
            }
        },
        {
            id: MenuId.TerminalTabContext,
            item: {
                command: {
                    id: "workbench.action.terminal.changeColorActiveTab" ,
                    title: ( localizeWithPath(_moduleId, 20, "Change Color..."))
                },
                group: "3_edit"
            }
        },
        {
            id: MenuId.TerminalTabContext,
            item: {
                command: {
                    id: "workbench.action.terminal.sizeToContentWidth" ,
                    title: terminalStrings.toggleSizeToContentWidth
                },
                group: "3_edit"
            }
        },
        {
            id: MenuId.TerminalTabContext,
            item: {
                command: {
                    id: "workbench.action.terminal.joinActiveTab" ,
                    title: ( localizeWithPath(_moduleId, 21, "Join Terminals"))
                },
                when: ( (TerminalContextKeys.tabsSingularSelection.toNegated())),
                group: "9_config"
            }
        },
        {
            id: MenuId.TerminalTabContext,
            item: {
                command: {
                    id: "workbench.action.terminal.unsplit" ,
                    title: terminalStrings.unsplit.value
                },
                when: ( (ContextKeyExpr.and(
                    TerminalContextKeys.tabsSingularSelection,
                    TerminalContextKeys.splitTerminal
                ))),
                group: "9_config"
            }
        },
        {
            id: MenuId.TerminalTabContext,
            item: {
                command: {
                    id: "workbench.action.terminal.killActiveTab" ,
                    title: terminalStrings.kill.value
                },
                group: "7_kill" ,
            }
        }
    ]);
    MenuRegistry.appendMenuItem(MenuId.EditorTitleContext, {
        command: {
            id: "workbench.action.terminal.moveToTerminalPanel" ,
            title: terminalStrings.moveToTerminalPanel
        },
        when: ( (ResourceContextKey.Scheme.isEqualTo(Schemas.vscodeTerminal))),
        group: '2_files'
    });
    MenuRegistry.appendMenuItem(MenuId.EditorTitleContext, {
        command: {
            id: "workbench.action.terminal.rename" ,
            title: terminalStrings.rename
        },
        when: ( (ResourceContextKey.Scheme.isEqualTo(Schemas.vscodeTerminal))),
        group: '2_files'
    });
    MenuRegistry.appendMenuItem(MenuId.EditorTitleContext, {
        command: {
            id: "workbench.action.terminal.changeColor" ,
            title: terminalStrings.changeColor
        },
        when: ( (ResourceContextKey.Scheme.isEqualTo(Schemas.vscodeTerminal))),
        group: '2_files'
    });
    MenuRegistry.appendMenuItem(MenuId.EditorTitleContext, {
        command: {
            id: "workbench.action.terminal.changeIcon" ,
            title: terminalStrings.changeIcon
        },
        when: ( (ResourceContextKey.Scheme.isEqualTo(Schemas.vscodeTerminal))),
        group: '2_files'
    });
    MenuRegistry.appendMenuItem(MenuId.EditorTitleContext, {
        command: {
            id: "workbench.action.terminal.sizeToContentWidth" ,
            title: terminalStrings.toggleSizeToContentWidth
        },
        when: ( (ResourceContextKey.Scheme.isEqualTo(Schemas.vscodeTerminal))),
        group: '2_files'
    });
    MenuRegistry.appendMenuItem(MenuId.EditorTitle, {
        command: {
            id: "workbench.action.createTerminalEditorSameGroup" ,
            title: terminalStrings.new,
            icon: Codicon.plus
        },
        alt: {
            id: "workbench.action.terminal.split" ,
            title: terminalStrings.split.value,
            icon: Codicon.splitHorizontal
        },
        group: 'navigation',
        order: 0,
        when: ( (ResourceContextKey.Scheme.isEqualTo(Schemas.vscodeTerminal)))
    });
}
function getTerminalActionBarArgs(location, profiles, defaultProfileName, contributedProfiles, terminalService, dropdownMenu) {
    let dropdownActions = [];
    let submenuActions = [];
    profiles = profiles.filter(e => !e.isAutoDetected);
    const splitLocation = (location === TerminalLocation.Editor || (typeof location === 'object' && 'viewColumn' in location && location.viewColumn === ACTIVE_GROUP)) ? { viewColumn: SIDE_GROUP } : { splitActiveTerminal: true };
    for (const p of profiles) {
        const isDefault = p.profileName === defaultProfileName;
        const options = { config: p, location };
        const splitOptions = { config: p, location: splitLocation };
        const sanitizedProfileName = p.profileName.replace(/[\n\r\t]/g, '');
        dropdownActions.push(( (new Action(
            "workbench.action.terminal.newWithProfile" ,
            isDefault ? ( localizeWithPath(_moduleId, 22, "{0} (Default)", sanitizedProfileName)) : sanitizedProfileName,
            undefined,
            true,
            async () => {
                const instance = await terminalService.createTerminal(options);
                terminalService.setActiveInstance(instance);
                await terminalService.focusActiveInstance();
            }
        ))));
        submenuActions.push(( (new Action(
            "workbench.action.terminal.split" ,
            isDefault ? ( localizeWithPath(_moduleId, 22, "{0} (Default)", sanitizedProfileName)) : sanitizedProfileName,
            undefined,
            true,
            async () => {
                const instance = await terminalService.createTerminal(splitOptions);
                terminalService.setActiveInstance(instance);
                await terminalService.focusActiveInstance();
            }
        ))));
    }
    for (const contributed of contributedProfiles) {
        const isDefault = contributed.title === defaultProfileName;
        const title = isDefault ? ( localizeWithPath(_moduleId, 22, "{0} (Default)", contributed.title.replace(/[\n\r\t]/g, ''))) : contributed.title.replace(/[\n\r\t]/g, '');
        dropdownActions.push(( (new Action(
            'contributed',
            title,
            undefined,
            true,
            () => terminalService.createTerminal({
                config: {
                    extensionIdentifier: contributed.extensionIdentifier,
                    id: contributed.id,
                    title
                },
                location
            })
        ))));
        submenuActions.push(( (new Action(
            'contributed-split',
            title,
            undefined,
            true,
            () => terminalService.createTerminal({
                config: {
                    extensionIdentifier: contributed.extensionIdentifier,
                    id: contributed.id,
                    title
                },
                location: splitLocation
            })
        ))));
    }
    const defaultProfileAction = dropdownActions.find(d => d.label.endsWith('(Default)'));
    if (defaultProfileAction) {
        dropdownActions = dropdownActions.filter(d => d !== defaultProfileAction).sort((a, b) => a.label.localeCompare(b.label));
        dropdownActions.unshift(defaultProfileAction);
    }
    if (dropdownActions.length > 0) {
        dropdownActions.push(( (new SubmenuAction('split.profile', ( localizeWithPath(_moduleId, 23, 'Split Terminal')), submenuActions))));
        dropdownActions.push(( (new Separator())));
    }
    const actions = dropdownMenu.getActions();
    dropdownActions.push(...Separator.join(...( (actions.map(a => a[1])))));
    const defaultSubmenuProfileAction = submenuActions.find(d => d.label.endsWith('(Default)'));
    if (defaultSubmenuProfileAction) {
        submenuActions = submenuActions.filter(d => d !== defaultSubmenuProfileAction).sort((a, b) => a.label.localeCompare(b.label));
        submenuActions.unshift(defaultSubmenuProfileAction);
    }
    const dropdownAction = ( (new Action('refresh profiles', ( localizeWithPath(_moduleId, 24, 'Launch Profile...')), 'codicon-chevron-down', true)));
    return { dropdownAction, dropdownMenuActions: dropdownActions, className: `terminal-tab-actions-${terminalService.resolveLocation(location)}` };
}

export { getTerminalActionBarArgs, setupTerminalMenus };
